import React, { useState, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment, CircularProgress } from "@mui/material";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import "../../styles/pages/TemplateManager.scss";
import DropDownWithLabelSizeTemplate from "../../components/DropdownWithLabelSizeTemplate.js";
import DropDownWithLabelTemplate from "../../components/DropDownWithLabelTemplate.js";
import TextFieldInputTemp from "../../components/CommonComponents/TextFieldInputTemp";
import {
  getNewBrandsAndcampaigns,
  getAssetdetails,
  getMarketList,
} from "../../services/apis";
import DropDownWithSearchTemplate from "../../components/DropDownWithSearchTemplate";
import { toast } from "react-toastify";
import { nameValidation } from "../../Uitls/Util";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@mui/material/Button";
import { templateSizes } from "../../Uitls/RightPanelToolBarItems";

export default function CreateTemplateModal(props) {
  const history = useHistory();
  const { setShowNewTemplate, showNewTemplate, assetType } = props;
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [preDefined, setPredefined] = useState(true);
  const [loader, setLoader] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(undefined);
  const [customTemp, setCustomTempSize] = React.useState(false);
  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    templateNameInput: "",
    templateSize: "",
    templateSizeType: "Pre-defined",
    Width: 0,
    Height: 0,
    templateType: [],
    promomatTempDocId: "ES-BVY-0064",
  });
  const closeCreateTempModal = (e) => {
    setShowNewTemplate(false);
    setLoader(false);
  };
  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      templateNameInput: "",
      templateSize: "",
      Width: 0,
      Height: 0,
      templateType: "",
    });
    setSelectedMarket("");
  };
  const { t } = useTranslation();
  React.useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: genericInfo?.brand === "— Not Brand Specific —" ? "-" : "",
    });
  }, [genericInfo.brand]);

  React.useEffect(() => {
    fetchBrandsAndCampaigns();
    fetchMarketData();
  }, []);

  //Fetch Brands and campaigns
  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });

          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(sortedData);
        }
      }
    });
  };

  const getBrandsToPopulate = () => {
    if (!brandsAndCampaigns || brandsAndCampaigns.length <= 0) {
      return [];
    }
    return brandsAndCampaigns;
  };

  function validateForm() {
    return (
      genericInfo.templateNameInput &&
      genericInfo.templateNameInput.trim() !== "" &&
      genericInfo.brand?.length > 0 &&
      genericInfo.market?.length > 0 &&
      genericInfo.templateType?.length > 0 &&
      (genericInfo.templateSize?.length > 0 ||
        (genericInfo.Width > 0 && genericInfo.Height > 0))
    );
  }
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "templateNameInput") {
      if (e.target.value.length > 500) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>,
          { autoClose: 1200, hideProgressBar: false },
        );
      }
    }

    setGenericInfo({ ...genericInfo, [name]: value });
    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandDamId);
        }
        brand.campaigns &&
          brand.campaigns.forEach((campaign) => {
            if (campaign.campaignName === value) {
              appData.setCampaignId(campaign.campaignId);
            }
          });
      });
    }
  };

  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save

        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        }
      }
    });
  };
  const handleChangeInfoDataBlur = (e) => {
    if (
      e.target.value.length < 3 &&
      e.target.value.length !== 0 &&
      e.target.value.trim() !== ""
    ) {
      toast.error(
        <div className="notificationText">
          {t("bannerManager.tempNameMinErr")}
        </div>,
      );
    }
  };

  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      setGenericInfo({ ...genericInfo, market: market.name });
      appData.setMarketCode(market.code);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        market: market.name,
      });
    }
  };
  const handleBrandChange = (brand) => {
    if (brand) {
      setSelectedBrand(brand);
      setGenericInfo({ ...genericInfo, brand: brand.brandName });
      appData.setBrandId(brand.brandDamId);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        brand: brand.brandName,
      });
    }
  };
  const handleGoToEditorScreen = (moduleInfo) => {
    if (!nameValidation(genericInfo.templateNameInput, "Template")) return;
    setLoader(true);
    appData.setActiveCards([]);
    const match = genericInfo.templateSize.match(/\d{2,4}x\d{2,4}/);
    var tempSizeRes = match[0].split("x");
    var moduleInfo = {};
    moduleInfo.assetType = "TEMPLATE";
    moduleInfo.brandName = genericInfo.brand;
    moduleInfo.assetName = genericInfo.templateNameInput.trim();
    moduleInfo.campaign = genericInfo.campaign;
    moduleInfo.campaignId = appData?.campaignId;
    moduleInfo.brandId = appData?.brandId;
    moduleInfo.marketCode = appData?.marketCode;
    moduleInfo.marketName = genericInfo.market;
    moduleInfo.width = preDefined ? tempSizeRes[0] : genericInfo.Width;
    moduleInfo.height = preDefined ? tempSizeRes[1] : genericInfo.Height;
    moduleInfo.comments = "";
    moduleInfo.description = "";
    moduleInfo.modules = [];
    moduleInfo.attributes = {
      customTemp: genericInfo?.templateSizeType === "Custom" ? true : false,
    };
    moduleInfo.isAnimated =
      genericInfo.templateType === "Animated " ? true : false;
    appData.setCustomTempSize(
      genericInfo?.templateSizeType === "Custom" ? true : false,
    );
    getAssetdetails(moduleInfo, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        if (err.response?.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
          toast.error(
            <div className="notificationText">
              {t("apiErrors.errTempExist")}
            </div>,
          );
        } else {
          toast.error(
            <div className="notificationText">{t("apiErrors.err500")}</div>,
          );
        }
        setLoader(false);
      } else {
        setGenericInfo(response.data);
        appData.updateGenericInfo({
          ...appData?.genericInfo,
          ...genericInfo,
        });

        appData.setAssetInfo({
          assetId: response.data.assetId,
          assetName: genericInfo.templateNameInput,
        });

        window.localStorage.setItem("assetId", response.data.assetId);
        history.push(`/banner-editor/${response?.data?.assetId}`);
        setLoader(false);
      }
    });
  };
  const templateSizeOptions = ["Pre-defined", "Custom"];
  const templateType = ["Static ", "Animated "];
  const handleChangeSizes = (e, id) => {
    let name = e.target.name;
    let value = e.target.value;
    setGenericInfo({
      ...genericInfo,
      templateSizeType: value,
      templateSize: "",
      Width: 0,
      Height: 0,
    });
  };

  const dropdownWidth = useRef(null);

  return (
    <>
      <Dialog
        open={showNewTemplate}
        onClose={closeCreateTempModal}
        className="  newTemplateModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        {loader && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress
              size="30px"
              className="customLoadermodules"
            />{" "}
          </>
        )}

        <div className="row newBnrModal">
          <div
            className="baseOnModalHeading col-md-5 createbannerhead"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
          >
            <p>{t("METADATA INFORMATION")}</p>
            <div className="details">
              <p className="sourcetag">Source</p>
              <p className="tagDescription">PromoMats</p>
              <hr className="custom-hr" />
            </div>
            <div className="details createdBtagy">
              <p className="sourcetag">Created by</p>
              <p className="tagDescription">-</p>
            </div>
            <div className="details">
              <p className="sourcetag">Created on</p>
              <p className="tagDescription">-</p>
            </div>
          </div>

          <div className="col-md-7 selectBrands customScrollBar">
            <TextField
              variant="standard"
              label={
                <>
                  {t("Template Name")} <span style={{ color: "red" }}>*</span>
                </>
              }
              name="templateNameInput"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges bnrtxtField"
              fullWidth={true}
              value={genericInfo.templateNameInput}
              onChange={handleChange}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ color: "gray", fontSize: "12px" }}
                  >
                    {genericInfo.templateNameInput?.length > 0 &&
                      `${genericInfo.templateNameInput?.length}/500 chars`}
                  </InputAdornment>
                ),
              }}
            ></TextField>

            <DropDownWithSearchTemplate
              options={{
                value: selectedBrand,
                name: "brand",
                label: (
                  <>
                    {t("Product")} <span style={{ color: "red" }}>*</span>
                  </>
                ),
                items: getBrandsToPopulate(),
                handleChange: handleBrandChange,
              }}
              menuWidth={
                dropdownWidth.current?.getBoundingClientRect().width * 0.95 ||
                undefined
              }
              className="custonScrollBar"
              marginTopVal="7px"
            />

            <DropDownWithSearchTemplate
              options={{
                value: selectedMarket,
                name: "market",
                label: (
                  <>
                    {t("Country")} <span style={{ color: "red" }}>*</span>
                  </>
                ),
                items: marketDataSource,
                handleChange: handleMarketChange,
              }}
              className="custonScrollBar"
            />

            <div className="newInputFieldTemp ">
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo.templateType || "",
                  name: "templateType",
                  label: (
                    <>
                      {t("bannerManager.templateType")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: templateType,
                  handleChange: handleChange,
                  className: "testBannersize",
                }}
              />
            </div>
            <div className="newInputFieldTemp newInputFieldTempChanges">
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo?.templateSizeType || "",
                  name: "templateSizeType",
                  label: (
                    <>
                      {t("Template Size")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: templateSizeOptions,
                  handleChange: handleChangeSizes,
                  className: "testBannersize",
                }}
              />
            </div>
            {genericInfo.templateSizeType === "Pre-defined" && (
              <div
                className={
                  genericInfo.templateSizeType === "Pre-defined"
                    ? "newSizeInputFieldTemp chooseSize newInputFieldTemp newSizeInputFieldTempWidth"
                    : "newSizeInputFieldTemp chooseSize2 newInputFieldTemp newSizeInputFieldTempWidth"
                }
              >
                <DropDownWithLabelSizeTemplate
                  options={{
                    value: genericInfo.templateSize || "",
                    name: "templateSize",
                    label: (
                      <>
                        {t("Choose Size")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ),
                    items: templateSizes,
                    handleChange: handleChange,
                    className: "testBannersize",
                  }}
                />
              </div>
            )}
            {genericInfo.templateSizeType === "Custom" && (
              <TextFieldInputTemp
                assetType={assetType}
                custom={true}
                setCustomSize={true}
                genericInfo={genericInfo}
                setGenericInfo={setGenericInfo}
                handleChange={handleChange}
                styleClass="hWTemplate2"
              />
            )}
          </div>
        </div>
        <DialogActions className="modalActions templateBtn">
          <Button
            onClick={() => {
              closeCreateTempModal();
              handleFormReset();
            }}
            color="primary"
            className="cancelBtntemp"
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            onClick={handleGoToEditorScreen}
            type="submit"
            className="temp-btn"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
            disabled={!validateForm()}
            autoFocus
          >
            {t("create template")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
